import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from './LoginButton';
import ChangeUserButton from './ChangeUserButton';
import { Typography } from '@mui/material';

const Login = () => {
  const [changeUser, setChangeUser] = useState(false)
  const { isAuthenticated, isLoading, error } = useAuth0();

  useEffect(() => {
      setChangeUser(error && error.message === "Acceso denegado")
  }, [error]);

  return (
    !isLoading && (
      <div className="App">
        {!isAuthenticated && !changeUser && <LoginButton onClick={(snapshot) => {console.log('login click', snapshot); }} />} 
        {changeUser && <ChangeUserButton />}
        {error && <Typography variant='h5' color='#9C0006'>{error.message}</Typography>}
      </div>
    )
  );
}

export default Login;
